import type { GaugeComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { isBound, widgetDatePatch } from "./_shared";

export const gaugeControlPanel: ControlPanelHandler<GaugeComponentSpec> = (spec, patch) => {
  spec.gauge_builder_misc = {
    ...spec.gauge_builder_misc,
    ...(patch.applyDate && !isBound(spec.gauge_builder_misc, "date", patch) && widgetDatePatch(patch.date)),
    ...(patch.applySubjects && !isBound(spec.gauge_builder_misc, "subject", patch) && patch.subjects),
  };
};
